/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { SxProps, Theme } from "@mui/material";

export const mergeSx = (...sx: Array<SxProps<Theme> | null | undefined>): SxProps<Theme> => {
  return sx.flatMap((s) => s).filter((s): s is NonNullable<typeof s> => Boolean(s));
};
